/**
 * Product analytics — thin wrapper over POST /api/analytics/track.
 * Separate from llm_telemetry (which is a cost/usage stream, not a
 * product-analytics stream).
 *
 * UTM: on first page load we snapshot ?utm_source/?utm_medium/?utm_campaign
 * into sessionStorage so subsequent events (which happen post-nav) still
 * carry attribution. Existing Splash/PostHog code stays untouched.
 */

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign"];
const SS_KEY = "leo_utm_snapshot_v1";

function _snapshotUtm() {
  try {
    if (typeof window === "undefined") return {};
    // Prefer existing snapshot so a mid-session nav doesn't wipe attribution.
    const existing = JSON.parse(window.sessionStorage.getItem(SS_KEY) || "null");
    if (existing) return existing;
    const params = new URLSearchParams(window.location.search);
    const snap = {};
    for (const k of UTM_KEYS) {
      const v = params.get(k);
      if (v) snap[k] = v;
    }
    if (Object.keys(snap).length) {
      window.sessionStorage.setItem(SS_KEY, JSON.stringify(snap));
    }
    return snap;
  } catch {
    return {};
  }
}

// Fire once on module load so the ?utm_* params are captured even when the
// first analytics event happens after client-side navigation strips them.
_snapshotUtm();

export async function trackEvent(event, meta = {}) {
  try {
    const base = process.env.REACT_APP_BACKEND_URL;
    const token = (typeof window !== "undefined" && window.localStorage.getItem("leo_token")) || "";
    if (!base || !token) return; // no-op if unauthenticated
    const utm = _snapshotUtm();
    await fetch(`${base}/api/analytics/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ event, meta, ...utm }),
      keepalive: true,
    });
  } catch {
    // never let analytics break the flow
  }
}
